import type { IconData } from '@stacksjs/iconify-core'

export const sadFaceFlat: IconData = {
  "body": "<g fill=\"none\"><path fill=\"#8fbffa\" d=\"M24 1.5C11.574 1.5 1.5 11.574 1.5 24S11.574 46.5 24 46.5S46.5 36.426 46.5 24S36.426 1.5 24 1.5\"/><path fill=\"#2859c5\" fill-rule=\"evenodd\" d=\"M17 17a2 2 0 1 0-4 0v2a2 2 0 1 0 4 0zm16-2a2 2 0 0 0-2 2v2a2 2 0 1 0 4 0v-2a2 2 0 0 0-2-2M18 35a6 6 0 0 1 12 0a2 2 0 1 0 4 0c0-5.523-4.477-10-10-10s-10 4.477-10 10a2 2 0 1 0 4 0\" clip-rule=\"evenodd\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default sadFaceFlat
